export const ORIGINATION_SELFIE_API = 'ORIGINATION_SELFIE_API';
export const ORIGINATION_URL = 'ORIGINATION_URL';
export const ORIGINATION_TERMS_URL = 'ORIGINATION_TERMS_URL';
export const ORIGINATION_POLICY_URL = 'ORIGINATION_POLICY_URL';
export const GOOGLE_ANALYTICS_ID = 'GOOGLE_ANALYTICS_ID';
export const GOOGLE_TAG_MANAGER_ID = 'GOOGLE_TAG_MANAGER_ID';
export const ENVIRONMENT = 'ENVIRONMENT';

export const getEnv = (key) => window.env[key];
